// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}

var faqTabTitles = document.querySelectorAll(".faq-tab-wrapper .faq-tab-title");
if(faqTabTitles){
  faqTabTitles.forEach(function(tabTitle){
    tabTitle.addEventListener('click',function(){
      faqTabTitles.forEach(function(tabTitle){
        tabTitle.classList.remove("active");
      });
      tabTitle.classList.add("active");
      
      var tab = tabTitle.getAttribute("data-tab-title");
      var tabWrappers = document.querySelectorAll(".faq-blocks-wrapper .accordion-wrapper");
      if(tabWrappers){
        tabWrappers.forEach(function(tabwrapper){
          tabwrapper.classList.remove("active");
          var tabContent = tabwrapper.getAttribute("data-tab");
          if(tab == tabContent){
            tabwrapper.classList.add("active");
          }
        });
      }
    });
  });
}
// accordions js end

(function() {
  faq_taggol();
})();


// Featured collection Deals of the week section

document.addEventListener("DOMContentLoaded", function() {
  var dealTimeSections = document.querySelectorAll(".timer-section");
  // console.log("dealTimeSections", dealTimeSections);
  if (dealTimeSections) {
    dealTimeSections.forEach(function(dealTimeSection, index) {
      // console.log("dealTimeSection", dealTimeSection);
      var dealTimeElem = dealTimeSection.querySelector(".deal-time");
      var dealTime = dealTimeElem?.getAttribute("deal-time");
      // console.log("dealTime", dealTime);

      // Convert HH:MM:SS to total seconds
      function timeStringToSeconds(timeString) {
        let [hours, minutes, seconds] = timeString.split(':').map(Number);
        return hours * 3600 + minutes * 60 + seconds;
      }

      // Get the remaining time, accounting for elapsed time and deal time changes
      function getRemainingTime(timerKey, totalSeconds, currentDealTime) {
        const storedStartTime = localStorage.getItem('startTime_' + timerKey);
        const storedTotalTime = localStorage.getItem('totalTime_' + timerKey);
        const storedDealTime = localStorage.getItem('dealTime_' + timerKey);

        // If the deal time has changed, reset the timer
        if (storedDealTime !== currentDealTime) {
          localStorage.setItem('dealTime_' + timerKey, currentDealTime);
          localStorage.setItem('startTime_' + timerKey, Math.floor(Date.now() / 1000));
          localStorage.setItem('totalTime_' + timerKey, totalSeconds);
          return totalSeconds; // Reset the timer with new deal time
        }

        if (storedStartTime && storedTotalTime) {
          const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
          const elapsedTime = currentTime - storedStartTime; // Time elapsed since countdown started
          let remainingTime = storedTotalTime - elapsedTime;

          return remainingTime > 0 ? remainingTime : 0; // Ensure non-negative remaining time
        }

        return totalSeconds; // If no stored time, return the total countdown time
      }

      // Start or continue countdown
      function startCountdown(timerKey, totalSeconds) {
        let timeInSeconds = getRemainingTime(timerKey, totalSeconds, dealTime);

        function updateTime() {
          if (timeInSeconds <= 0) {
            clearInterval(timerInterval);
            // Set to 00:00:00 when countdown finishes
            dealTimeSection.querySelector('.hours-tens').textContent = '0';
            dealTimeSection.querySelector('.hours-units').textContent = '0';
            dealTimeSection.querySelector('.minutes-tens').textContent = '0';
            dealTimeSection.querySelector('.minutes-units').textContent = '0';
            dealTimeSection.querySelector('.seconds-tens').textContent = '0';
            dealTimeSection.querySelector('.seconds-units').textContent = '0';
            return;
          }

          timeInSeconds--;

          const hours = Math.floor(timeInSeconds / 3600);
          const minutes = Math.floor((timeInSeconds % 3600) / 60);
          const seconds = timeInSeconds % 60;

          dealTimeSection.querySelector('.hours-tens').textContent = Math.floor(hours / 10);
          dealTimeSection.querySelector('.hours-units').textContent = hours % 10;
  
          dealTimeSection.querySelector('.minutes-tens').textContent = Math.floor(minutes / 10);
          dealTimeSection.querySelector('.minutes-units').textContent = minutes % 10;

          dealTimeSection.querySelector('.seconds-tens').textContent = Math.floor(seconds / 10);
          dealTimeSection.querySelector('.seconds-units').textContent = seconds % 10;
        }

        const timerInterval = setInterval(updateTime, 1000);

        // Store the start time and total time in localStorage if it's a new timer
        if (!localStorage.getItem('startTime_' + timerKey)) {
          const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
          localStorage.setItem('startTime_' + timerKey, currentTime);
          localStorage.setItem('totalTime_' + timerKey, totalSeconds);
          localStorage.setItem('dealTime_' + timerKey, dealTime);
        }
      }

      const timerKey = 'timer_' + index;
      const totalSeconds = timeStringToSeconds(dealTime);
      // console.log("totalSeconds", totalSeconds);
      startCountdown(timerKey, totalSeconds);
    });
  }
});

function updateOrderMessage() {
  const now = new Date();
    
  let targetTime = new Date();
  targetTime.setHours(16, 0, 0, 0); // 16:00 (4 PM)

  const timeDifference = targetTime - now;
    
  const orderMessageElement = document.querySelector('.order-message');

  if (timeDifference > 0) {
    // Time remaining in hours and minutes
    const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);

    // Display message for orders placed before 4 PM
    if(orderMessageElement){
      orderMessageElement.innerHTML = `
        Order within <span class="countdown"><b>${hours} Hours ${minutes} Minutes </b></span> and order will ship today with Free Shipping.
      `;
    }
    
    // Update the countdown every minute
    setTimeout(updateOrderMessage, 60000);
  }
}

  // Initial call to display the order message
  updateOrderMessage();



//Product page Tab section
var tabTitles = document.querySelectorAll(".product-tab-wrapper .tab-title");
if(tabTitles){
  tabTitles.forEach(function(tabTitle, index){
    tabTitle.addEventListener('click',function(){
      var swiperElement = tabTitle.closest(".swiper"); // Get the Swiper container
      var swiperInstance = swiperElement.swiper; // Get the Swiper instance
      //console.log("Swiper", swiperInstance);
      //console.log("Index", index);

      // Slide to the clicked tab and center it
      swiperInstance.slideTo(index);
      
      tabTitles.forEach(function(tabTitle){
        tabTitle.classList.remove("active");
        tabTitle.classList.remove('swiper-slide-active');
      });
      tabTitle.classList.add("active");
      tabTitle.classList.add('swiper-slide-active');
      
      var tab = tabTitle.getAttribute("data-tab-title");
      var tabWrappers = document.querySelectorAll(".product-tab-contents .tab-content");
      if(tabWrappers){
        tabWrappers.forEach(function(tabwrapper){
          tabwrapper.classList.remove("active");
          var tabContent = tabwrapper.getAttribute("data-tab");
          if(tab == tabContent){
            tabwrapper.classList.add("active");
          }
        });
      }
    });
  });
}

var review_badge = document.querySelector(".jdgm-preview-badge");
if(review_badge){
  review_badge.addEventListener('click',function(){
    // console.log("cliked..");
   var tabs = document.querySelectorAll(".product-tab-titles .tab-title");
    // console.log("tabs",tabs);
    if(tabs){
      tabs.forEach(function(tab){
        tab.classList.remove("active");
      })
    }
    document.querySelector(".product-tab-titles .tab-title[data-tab-title='Reviews']").click();
  });
}

let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
items && items.forEach(item => {
    item.addEventListener("mouseover", () => {
        item.setAttribute("open", !0),
        item.querySelector("ul").addEventListener("mouseleave", () => {
            item.removeAttribute("open")
        }),
        item.addEventListener("mouseleave", () => {
            item.removeAttribute("open")
        })
    })
});

var category_checkboxes = document.querySelectorAll(".facets-layout.category .mobile-facets__checkbox");
if(category_checkboxes){
  category_checkboxes.forEach(function(checkbox){
    checkbox.addEventListener('click',function(){
      checkbox.setAttribute("checked","");
    });
  })
}

// const backToTopButton = document.querySelector(".back-to-top");
//   window.addEventListener('scroll', function() { 
//     var cut_offset = 500; 
   
//     if (window.scrollY > cut_offset )
//     {
//       backToTopButton.classList.add("active");
//     }
//     else{
//       backToTopButton.classList.remove("active");
//     }
//   });

// backToTopButton.addEventListener("click", function(event) {
//     event.preventDefault(),
//     window.scrollTo({
//         top: 0,
//         behavior: "smooth"
//     })
// });

//load more button collection page
document.addEventListener('DOMContentLoaded', function() {
        // Handle scroll event on the window
  var custom_ofset = 1000;
        window.addEventListener('scroll', function() {
              if (window.scrollY > custom_ofset) {
                  setTimeout(() => {
                         let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;                
                        scroll_function(loadMoreBtn);
                    }, 1000);
                 custom_ofset = custom_ofset + 1000;
              }
        });
    });
